<script setup>
import { computed } from 'vue'
import { formatNumber } from 'devextreme/localization'
import { getI18n } from '@/plugins/i18n'

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
})

const i18n = getI18n()

const totalRows = computed(() => props.data?.rows_count || 0)
const checkedRows = computed(() => props.data?.confirmed_rows_count || 0)
const progress = computed(() => totalRows.value > 0 ? checkedRows.value / totalRows.value : 0)
const percentage = computed(() => Math.round(progress.value * 100))
</script>

<template>
  <q-scroll-area
    class="fit"
    :thumb-style="{ display: 'none' }"
    :bar-style="{ display: 'none' }"
  >
    <div class="q-pa-sm">
      <div class="text-subtitle2 q-mb-sm">
        {{ i18n.t('warehouseDocument.receiptSummary.title') }}
      </div>

      <q-card
        flat
        bordered
        class="q-mb-sm"
      >
        <q-card-section class="q-pa-sm">
          <div class="text-caption text-weight-bold text-uppercase q-mb-sm">
            {{ i18n.t('warehouseDocument.receiptSummary.progress') }}
          </div>
          <div class="text-weight-bold text-positive q-mb-xs">
            {{ i18n.t('warehouseDocument.receiptSummary.completed', { percentage }) }}
          </div>
          <q-linear-progress
            :value="progress"
            color="positive"
            track-color="grey-3"
            size="8px"
            rounded
            :aria-label="i18n.t('warehouseDocument.receiptSummary.progressLabel', { percentage })"
          />
          <q-separator class="q-my-sm" />
          <div
            v-for="[label, value] in [
              ['totalRows', totalRows],
              ['checkedRows', checkedRows],
              ['expectedQuantity', formatNumber(props.data?.expected_quantity_total ?? 0, '#,##0.######')],
              ['receivedQuantity', formatNumber(props.data?.received_quantity_total ?? 0, '#,##0.######')],
            ]"
            :key="label"
            class="row justify-between items-baseline q-gutter-x-sm q-mt-xs text-caption"
          >
            <span class="col">{{ i18n.t(`warehouseDocument.receiptSummary.${label}`) }}</span>
            <span class="text-weight-bold">{{ value }}</span>
          </div>
        </q-card-section>
      </q-card>
    </div>
  </q-scroll-area>
</template>
